import { SET_HIDE_UNUSED_GROUPS } from './constants';

export function setHideUnusedGroups(hideUnusedGroups: boolean) {
    return {
        type: SET_HIDE_UNUSED_GROUPS,
        payload: {
            hideUnusedGroups
        }
    };
}
